import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SesamLink from 'Common/Links/SesamLink';
import Button from 'Common/Button/Button';
import Page from '../../../components/page';
import PageHeader, { PageHeaderGroup, PageHeaderTitle } from '../../../components/page-header';
import { TabbedNav } from '../../../components/tabbed-nav/TabbedNav.view';
import { EntitiesTabs } from 'src/containers/EntitiesTabs.container';

const SystemsParent = (props) => (
  <Page>
    <PageHeader>
      <PageHeaderTitle>Systems</PageHeaderTitle>
      <PageHeaderGroup>
        <Button theme="primary" onClick={props.onRefresh}>
          Refresh
        </Button>
        <SesamLink to={`/subscription/${props.subId}/systems/new`} buttonLink={true}>
          <Button theme="primary">New system</Button>
        </SesamLink>
      </PageHeaderGroup>
    </PageHeader>
    <EntitiesTabs subId={props.subId} entityType="systems">
      {props.children}
    </EntitiesTabs>
  </Page>
);

SystemsParent.propTypes = {
  children: PropTypes.node,
  subId: PropTypes.string.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    subId: state.subscription.id,
    subscriptionInfo: state.subscription.info,
  };
}

export default connect(mapStateToProps)(SystemsParent);
